import { Fragment, useEffect, useState } from "react";
import { Button, Dropdown, Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

import ReactDatatable from "@ashvin27/react-datatable";

import _ from "lodash";

import moment from "moment";

import { dataTableConfig } from "../configs/data-table.config";

import { DatasetDefault, DatasetModel } from "../models/dataset.model";
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../models/requestInputOutputParams.model";

import FileUpload from "./FileUpload";
import ImportationDataService from "../services/importationData.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCogs, faFileCode, faFileCsv, faFileDownload, faFileExport, faFileImport, faRefresh } from "@fortawesome/free-solid-svg-icons";

import EscapeOutside from "react-escape-outside"
import ImportationLogService from "../services/importationLog.service";
import storageService from "../services/storage.service";
import { t } from "i18next";
import { type } from "os";
import { FileExportService } from "../services/fileExport.service";
import UtilService from "../services/util.service";

const ModalImport = (props: any) => {
    const { t } = useTranslation();

    const { cancel, close, show, title } = props;

    const user = storageService.getUser();
    const importationEntity = storageService.getImportEntity();

    const [isLoading, setLoading] = useState(false);
    const [showImportationLog, setShowImportationLog] = useState(false);

    // -- IMPORTATION-DATA -- //

    const [importationData, setImportationData] = useState<DatasetModel>();
    const [importationDataSet, setImportationDataSet] = useState<DatasetModel>(
        {
            ...JSON.parse(JSON.stringify(DatasetDefault)),
            dataset: 'importation_data',
            filters: {
                entity: [importationEntity],
                user_id: [],
                locale_id: [user.localeId]
            },
            sort: {
                field: 'created_at',
                orientation: 'desc'
            }
        }
    );

    const [dataset,setDataset]=useState<DatasetModel>(
        {
            ...JSON.parse(JSON.stringify(DatasetDefault)),
            dataset: 'importation_detail',
            filters: {
                importation_data_id: []
            }
        
    });

    const importationDataColumns = [
        {
            key: "createdAt",
            text: t("IMPORT_MODAL.DATE"),
            align: "center",
            sortable: false,
            cell: (record) => {
                return record.createdAt ?  UtilService.formatDateTime(record.createdAt, user.locale.formatDateTime) : '';
            },
        },
        {
            key: "fileName",
            text: t("IMPORT_MODAL.FILE_NAME"),
            align: "center",
            sortable: false
        },
        {
            key: "userFullname",
            text: t("IMPORT_MODAL.USER"),
            align: "center",
            sortable: false
        },
        {
            key: "status",
            text: t("IMPORT_MODAL.STATUS"),
            align: "center",
            sortable: false,
            cell: (record) => {
                // Aqui você deve substituir 'record.status' pelo caminho correto para os dados do status
                const status = record.status;
                const translatedStatus = t(`STATUS_TRANSLATIONS.${status}`);
                return translatedStatus;
            }
        },
        {
            key: "action",
            text: t('ACTIONS'),
            className: "action",
            width: 100,
            align: "center",
            sortable: false,
            cell: (record) => {
                return (
                    <Fragment>
                        <Dropdown className='btn-toolbar'>
                            <Dropdown.Toggle
                                as={Button}
                                variant='primary'
                                size='sm'
                                className='me-2'>
                                <FontAwesomeIcon icon={faCogs} className='me-2' />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className='dashboard-dropdown dropdown-menu-left mt-2'>
                                <Dropdown.Item
                                    className='fw-bold'
                                    onClick={() => openOutsideLog(record.id)}
                                >
                                    <FontAwesomeIcon icon={faFileCode} className='me-2' /> Log
                                </Dropdown.Item>
                                {/* <Dropdown.Item
                                    className='fw-bold'
                                    onClick={() => exportTo([record.id_importation_data, 'excel'])}
                                >
                                    <FontAwesomeIcon icon={faFileExcel} className='me-2' /> Excel
                                </Dropdown.Item> */}
                                <Dropdown.Item
                                    className='fw-bold'
                                    onClick={() => {
                                        FileExportService.Export(
                                            { ...RequestInputOutputParamsModelDefault, datasets: [{...dataset, filters:{importation_data_id: [record.id]}}] },
                                            "ImportationDetail",
                                            'Csv'
                                          )}
                                    }
                                >
                                    <FontAwesomeIcon icon={faFileCsv} className='me-2' /> {t("EXPORT")}
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Fragment>
                );
            }
        }
    ];
    const importationDataTableConfig = {
        ...dataTableConfig,
        key_column: "id_importation_data",
        language: {
            filter: t(`DATA_GRID.SEARCH`),
            info: t(`DATA_GRID.INFO_START`) +
                " _START_ " + t(`DATA_GRID.INFO_TO`) +
                " _END_ " + t(`DATA_GRID.INFO_TOTAL`) +
                " _TOTAL_ " + t(`DATA_GRID.INFO_RECORDS`),
            no_data_text: t(`DATA_GRID.NO_RECORDS_FOUND`),
            pagination: {
                first: t(`DATA_GRID.BUTTON_FIRST`),
                previous: t(`DATA_GRID.BUTTON_PREVIOUS`),
                next: t(`DATA_GRID.BUTTON_NEXT`),
                last: t(`DATA_GRID.BUTTON_LAST`),
            },
        },
        sort: { column: "created_at", order: "desc" }
    };
    const getImportationData = async (dataTable: any) => {
        setLoading(true);

        importationDataSet.filters.entity = [importationEntity];

        let requestParams: RequestInputOutputParamsModel = {
            ...RequestInputOutputParamsModelDefault,
            datasets: [importationDataSet]
        };

        if (dataTable !== null && requestParams?.datasets) {
            let dataSet = requestParams.datasets[0];
            dataSet.sort.field = dataTable.sort_order.column;
            dataSet.sort.orientation = dataTable.sort_order.order;

            let pagination = dataSet.pagination;
            pagination.page_number = dataTable.page_number;
            pagination.records_pages = dataTable.page_size;
        } else {
            let pagination = requestParams.datasets[0].pagination;
            pagination.page_number = DatasetDefault.pagination.page_number;
            pagination.records_pages = DatasetDefault.pagination.records_pages;
        }

        const response: any = await ImportationDataService.getPaginatedList(requestParams);

        if (response.success && response.result) {
            let dataSetModel: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'importation_data' }));
            setImportationData(dataSetModel);
        } else {
            console.log('response error');
        }

        setLoading(false);
    };

    // -- IMPORTATION-LOG -- //

    const [importationLog, setImportationLog] = useState<DatasetModel>();
    const [importationLogSet, setImportationLogSet] = useState<DatasetModel>(
        {
            ...JSON.parse(JSON.stringify(DatasetDefault)),
            dataset: 'importation_log',
            filters: {
                importation_data_id: [],
                user_id: [],
                locale_id: [user.localeId]
            },
            sort: {
                field: 'createdAt',
                orientation: 'desc'
            }
        }
    );
    const importationLogColumns = [
        {
            key: "dateLog",
            text: t("IMPORT_MODAL.DATE"),
            align: "left",
            sortable: false,
            cell: (record) => {
                return record.dateLog ?  UtilService.formatDateTime(record.dateLog, user.locale.formatDateTime) : '';
            },
        },
        {
            key: "message",
            text: t("IMPORT_MODAL.MESSAGE"),
            align: "left",
            sortable: false,
            cell: (record) => {
                console.log('inex',record);
                const message = record.message || "";

                const parts = message.split(":");
                const key = parts[0].trim();
                const rest = parts.slice(1).join(":").trim();

                const translated = t(`IMPORT_MODAL.${key}`, key);

                return rest ? `${translated}: ${rest}` : translated;
            }            
        }          
    ];
    const importationLogTableConfig = {
        ...dataTableConfig,
        show_pagination: false,
        show_info: false,
        language: {
            filter: t(`DATA_GRID.SEARCH`),
            info: t(`DATA_GRID.INFO_START`) +
                " _START_ " + t(`DATA_GRID.INFO_TO`) +
                " _END_ " + t(`DATA_GRID.INFO_TOTAL`) +
                " _TOTAL_ " + t(`DATA_GRID.INFO_RECORDS`),
            no_data_text: t(`DATA_GRID.NO_RECORDS_FOUND`),
            pagination: {
                first: t(`DATA_GRID.BUTTON_FIRST`),
                previous: t(`DATA_GRID.BUTTON_PREVIOUS`),
                next: t(`DATA_GRID.BUTTON_NEXT`),
                last: t(`DATA_GRID.BUTTON_LAST`),
            }
        },
        sort: { column: "createdAt", order: "desc" }        
    };
    const getImportationLog = async (importationId: any) => {
        setLoading(true);
        importationLogSet.filters.importation_data_id = [importationId];

        let requestParams: RequestInputOutputParamsModel = {
            ...RequestInputOutputParamsModelDefault,
            datasets: [importationLogSet]
        };        

        const response: any = await ImportationLogService.getPaginatedList(requestParams);

        if (response.success && response.result) {
            let dataSetModel: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'importation_log' }));
            setImportationLog(dataSetModel);
        } else {
            console.log('response error');
        }        

        setLoading(false);
    };

    // -- -- //

    const tableChangeHandler = async (data: any) => {
        await getImportationData(data);
    };

    const handleEscapeOutside = () => { setShowImportationLog(false); }
    const openOutsideLog = (importationId: any) => {
        setShowImportationLog(true);
        getImportationLog(importationId);
    }

    // -- -- //    

    useEffect(() => {
        if (props.show) {
            getImportationData(null);
        }
    }, [props.show]);

    return (
        <>
            <Modal size="xl" as={Modal.Dialog} centered show={show} onHide={close}>
                <Modal.Header>
                    <Modal.Title className='h6'>{title}</Modal.Title>
                  
                    
                    <Button variant='close' aria-label='Close' onClick={close} />
                </Modal.Header>
                <Modal.Body>
                <Button variant='primary' aria-label='Reload' onClick={()=>{getImportationData(null)}}>
                        <FontAwesomeIcon icon={faRefresh}  />
                    </Button>
                    <ReactDatatable
                        config={importationDataTableConfig}
                        records={importationData?.data ? importationData?.data : []}
                        columns={importationDataColumns}
                        dynamic={true}
                        total_record={importationData?.pagination?.total_records ? importationData?.pagination?.total_records : 0}
                        onChange={tableChangeHandler}
                        className='table table-hover user-table align-items-center'
                        sort={{ column: "created_at", order: "desc" }}
                    />

                    {showImportationLog && (<hr></hr>)}

                    {
                        showImportationLog &&
                        (
                            <EscapeOutside onEscapeOutside={handleEscapeOutside}>
                                <ReactDatatable
                                    config={importationLogTableConfig}
                                    records={importationLog?.data ? importationLog?.data : []}
                                    columns={importationLogColumns}
                                    dynamic={true}
                                    className='table table-hover user-table align-items-center'
                                    sort={{ column: "created_at", order: "desc" }}
                                />
                            </EscapeOutside>
                        )
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className={"btn btn-outline-primary"}
                        onClick={()=>{
                            FileExportService.Export(
                                { ...RequestInputOutputParamsModelDefault, datasets: [{...dataset}], parameters: {'plan_code': importationEntity} },
                                "ImportationModel",
                                'Csv'
                              )
                        }}
                    >
                        <FontAwesomeIcon icon={faFileDownload} className='me-2' />
                        Modelo
                    </button>

                    <FileUpload
                        entityToImport={importationEntity}
                        onSuccess={getImportationData}
                    />

                    <Button
                        variant='link'
                        className='text-gray ms-auto'
                        onClick={close}>
                        {cancel}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ModalImport;